import { injectable } from "tsyringe";
import { MANAGE_CONFIG } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ManageConfigResponseEntity } from "../domain/entities/ManageConfigResponseEntity";
import { IManageConfigRepository } from "../domain/repositories/IManageConfigRepository";
import {
  ManageConfigFormRequestModel,
  ManageConfigListRequestModel,
} from "./model/ManageConfigModels";

@injectable()
export class ManageConfigImpl implements IManageConfigRepository {
  async getList(
    params: ManageConfigListRequestModel,
  ): Promise<ListBaseApiResponseModel<ManageConfigResponseEntity>> {
    return await client.get(MANAGE_CONFIG.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<ManageConfigResponseEntity>> {
    return await client.get(`${MANAGE_CONFIG.DETAIL}/${params.code}`);
  }

  async create(
    body: ManageConfigFormRequestModel,
  ): Promise<BaseApiResponseModel<ManageConfigResponseEntity>> {
    return await client.post(MANAGE_CONFIG.CREATE, body);
  }

  async update(
    body: ManageConfigFormRequestModel,
  ): Promise<BaseApiResponseModel<ManageConfigResponseEntity>> {
    return await client.put(`${MANAGE_CONFIG.UPDATE}/${(body as any)?.code}`, body);
  }

  async delete(params: {
    code: string;
  }): Promise<BaseApiResponseModel<ManageConfigResponseEntity>> {
    return await client.delete(`${MANAGE_CONFIG.DELETE}/${params.code}`);
  }
}
